import { combineReducers } from "redux";
import userLoginReducer from "./userLoginReducer";
import userSignupReducer from "./userSignupReducer";
import initialSearchReducer from "./InitialSearch"
import topFiveProfilesReducer  from "./topFiveProfiles";
import boardReducer  from "./boardsReducer";
import clientReducer  from "./ClientsReducer";
export default combineReducers({
    user: userLoginReducer,
    newUser: userSignupReducer,
    profile: initialSearchReducer,
    topProfiles: topFiveProfilesReducer,
    boards: boardReducer.boardsReducer,
    boardsEmail: boardReducer.boardsEmailReducer,
    client: clientReducer
});